module.exports = __webpack_public_path__ + "static/i-asimov-5f9527d28562a6790a546849e255e61f.jpg";